import { useState, useEffect } from "react";

export const useTimeProtection = () => {
  const [startTime] = useState(Date.now());

  const checkTiming = () => {
    const timeTaken = Date.now() - startTime;
    
    // Troppo veloce (< 2 secondi) = probabile bot
    if (timeTaken < 2000) {
      return {
        isValid: false,
        reason: "too_fast",
        timeTaken,
      };
    }

    // Troppo lento (> 5 minuti) = warning
    if (timeTaken > 300000) {
      return {
        isValid: true,
        reason: "too_slow",
        timeTaken,
      };
    }

    return {
      isValid: true,
      reason: "ok",
      timeTaken,
    };
  };

  return {
    checkTiming,
    startTime,
  };
};
